import { api, runtime } from "../api.js";
import { escapeHtml, safeUrl } from "../utils.js";

let mapPromise;
let regionTimer;

function regionImage(region) {
  return `/legacy/images/regioni/${region.toLowerCase().replaceAll(" ", "").replaceAll("'", "")}.svg`;
}

function homeShell(content) {
  return `<div class="legacy-home">
    <div class="map-logo-wrap">
      <div class="big-map-container">
        <div class="legacy-header"><a class="legacy-logo" href="/" data-link aria-label="FIPAV Online"></a></div>
        <div class="legacy-menu"><div><a href="https://fipavonline.it/login/"><span class="legacy-login-icon" aria-hidden="true"></span> Login</a></div></div>
      </div>
      <div class="big-map"><div id="committee-map" class="committee-map-static"><div class="map-wait">Caricamento cartina…</div></div></div>
    </div>
    <div class="legacy-main" id="main-content">
      <a class="app-banner" href="https://fipavonline.it/app_preview/" target="_blank" rel="noopener">
        <img src="https://fipavonline.it/app_preview/assets/img/store/google-play-badge.png" alt="Google Play">
        <span><strong>FIPAVONLINE</strong><small>Se la pallavolo è la tua passione</small><small>Scarica su App Store e Google Play</small></span>
        <img src="https://fipavonline.it/app_preview/assets/img/store/apple_store_100_it.png" alt="App Store">
      </a>
      <section class="legacy-regions" aria-label="Comitati">${content}</section>
    </div>
    <footer class="legacy-footer">
      <div class="legacy-footer-logo"></div>
      <div id="legacy-footer-links"></div>
      <div class="legacy-copyright">
        <p>© Copyright Manufacturing Point Software s.r.l. PIVA: 02888940786 - tutti i diritti riservati - <a href="https://fipavonline.it/infoPrivacy.html">Privacy &amp; Cookie</a></p>
        <p>Manufacturing Point software e la Federazione Italiana Pallavolo si impegnano attivamente a proteggere i propri dati dall'accesso non autorizzato attraverso il web scraping.</p>
        <p>Qualsiasi tentativo di acquisire informazioni senza autorizzazione sarà considerato una violazione delle politiche di tutela dei dati e dei dati personali e sarà perseguito legalmente.</p>
      </div>
    </footer>
  </div>`;
}

function committeeLinks(committees) {
  return committees.map((committee) => `<a href="/live?comi=${encodeURIComponent(committee.id)}" data-committee="${escapeHtml(committee.id)}" data-link>${escapeHtml(committee.nome
    .toUpperCase()
    .replace("COMITATO REGIONALE", "C.R.")
    .replace("COMITATO PROVINCIALE", "C.P.")
    .replace("COMITATO TERRITORIALE", "C.T."))}</a>`).join(" <span>|</span> ");
}

function loadMapKit() {
  if (!runtime.mapkitToken) return Promise.resolve(false);
  if (window.mapkit) return Promise.resolve(true);
  if (mapPromise) return mapPromise;
  mapPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js";
    script.crossOrigin = "anonymous";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.head.append(script);
  });
  return mapPromise;
}

async function renderMap(regions) {
  const mapElement = document.querySelector("#committee-map");
  if (!runtime.mapkitToken) {
    mapElement.innerHTML = `<div class="map-unavailable"><img src="/legacy/images/ball.png" alt=""><strong>Cartina dei comitati</strong><span>Serve il token MapKit autorizzato per public.fipavonline.it</span></div>`;
    return;
  }
  if (!await loadMapKit() || !window.mapkit) {
    mapElement.innerHTML = '<div class="map-unavailable"><strong>Cartina momentaneamente non disponibile</strong></div>';
    return;
  }
  window.mapkit.init({ authorizationCallback: (done) => done(runtime.mapkitToken) });
  mapElement.replaceChildren();
  const map = new window.mapkit.Map("committee-map", { showsMapTypeControl: false });
  const annotationsByRegion = Object.fromEntries(Object.entries(regions).map(([region, value]) => [region,
    (value.comitati || [])
      .filter((item) => Number.isFinite(Number(item.lat)) && Number.isFinite(Number(item.long)))
      .map((item) => {
      const marker = new window.mapkit.MarkerAnnotation(
        new window.mapkit.Coordinate(Number(item.lat), Number(item.long)),
        {
          color: Number(item.is_regione) === 1 ? "#c14141" : "#3888ce",
          glyphImage: { 1: "/legacy/images/ball.png" },
        },
      );
      marker.data = item;
      return marker;
    }),
  ]));

  let activeAnnotations = [];
  let automatic = true;
  const regionNames = Object.keys(annotationsByRegion);
  const cycleOrder = ["Lazio", ...regionNames.filter((name) => name !== "Lazio").sort(() => Math.random() - 0.5)];
  let cycleIndex = 0;

  const showRegion = (region) => {
    clearTimeout(regionTimer);
    if (activeAnnotations.length) map.removeAnnotations(activeAnnotations);
    activeAnnotations = annotationsByRegion[region] || [];
    if (activeAnnotations.length) {
      map.addAnnotations(activeAnnotations);
      map.showItems(activeAnnotations);
    }
    if (automatic) {
      regionTimer = window.setTimeout(() => {
        cycleIndex = (cycleIndex + 1) % cycleOrder.length;
        showRegion(cycleOrder[cycleIndex]);
      }, 4500);
    }
  };

  document.querySelectorAll("[data-map-region]").forEach((control) => control.addEventListener("click", () => {
    automatic = false;
    showRegion(control.dataset.mapRegion);
  }));
  showRegion(cycleOrder[0] || regionNames[0]);
}

export async function homeView(signal) {
  document.title = "fipavonline.it - Campionati provinciali e regionali FIPAV";
  document.querySelector("#app").innerHTML = homeShell('<div class="legacy-loading">Caricamento comitati…</div>');
  try {
    const data = await api.committees(signal);
    const regions = data.regioni || {};
    document.querySelector(".legacy-regions").innerHTML = Object.entries(regions).map(([region, value]) => `<article class="legacy-region">
      <button type="button" class="legacy-region-image" data-map-region="${escapeHtml(region)}" aria-label="Mostra ${escapeHtml(region)} sulla cartina"><img src="${safeUrl(regionImage(region))}" alt=""></button>
      <div><h2><button type="button" data-map-region="${escapeHtml(region)}">${escapeHtml(region)}</button></h2><p>${committeeLinks(value.comitati || [])}</p></div>
    </article>`).join("");
    document.querySelector("#legacy-footer-links").innerHTML = Object.entries(regions).map(([region, value]) => `<div><strong>${escapeHtml(region)}</strong>${(value.comitati || []).map((item) => `<a href="/live?comi=${encodeURIComponent(item.id)}" data-committee="${escapeHtml(item.id)}" data-link>${escapeHtml(item.nome)}</a>`).join("")}</div>`).join("");
    await renderMap(regions);
  } catch (error) {
    if (error?.name === "AbortError") return;
    const regions = document.querySelector(".legacy-regions");
    if (regions) regions.innerHTML = `<div class="legacy-loading">${escapeHtml(error.message)}</div>`;
  }
}

export function stopHomeCycle() {
  clearTimeout(regionTimer);
}
